import { createSelector } from 'reselect'

const userAgreementSelector = ({ userAgreement }) => userAgreement

export const isUserAgreementPopupOpenSelector = createSelector(
  userAgreementSelector,
  ({ open }) => open
)

export const onAgreeSelector = createSelector(
  userAgreementSelector,
  ({ onAgree }) => onAgree
)

export const agreementNameSelector = createSelector(
  userAgreementSelector,
  ({ name }) => name
)
